import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorunAsync, computed, observable, reaction, runInAction } from "mobx";
import { config } from "../config";
import { Agent } from "../services/agent";
import { RootStore } from "./root-store";

export enum StartMenuState{
	open,
	closed,
	pinned
}

export enum ProjectDashboardLayout{
	grid,
	list
}

export enum Sort{
	asc,
	desc
}

autorunAsync(async () =>
	{
		if(RootStore.authStore.loggedIn && RootStore.authStore.userId && RootStore.uiStore.optionsLoaded && !RootStore.authStore.impersonateLeaving){
			await Agent.User.saveOptions(RootStore.uiStore.optionData);
		}
	},
	// tslint:disable-next-line:align
	300
);

export class UIStore {
	@observable startMenuState: StartMenuState = StartMenuState.closed;
	@observable optionsLoaded = false;
	@observable projectDashboardLayout: ProjectDashboardLayout = ProjectDashboardLayout.grid;
	@observable projectDashboardSort: Sort = Sort.desc;
	@observable pinnedProjects: string[] = [];
	@observable lastLocation: string = null;
	@observable introModal: boolean = true;
	@observable releaseVersionViewed: number = 0;

	constructor(){
		reaction(
			() => RootStore.authStore.loggedIn,
			async (loggedIn) => {
				if(loggedIn && RootStore.authStore.userId){
					await this.loadOptions();
				}
			}
		);
	}

	@computed get optionData(){
		return {
			"startMenuState": this.startMenuState,
			"projectDashboardLayout": this.projectDashboardLayout,
			"projectDashboardSort": this.projectDashboardSort,
			"pinnedProjects": this.pinnedProjects.slice(),
			"lastLocation": this.lastLocation,
			"introModal": this.introModal,
			"releaseVersionViewed": this.releaseVersionViewed
		};
	}

	@computed get areOptionsLoaded(){
		return this.optionsLoaded;
	}

	@action async loadOptions(){
		let optionData = await Agent.User.getOptions();
		runInAction(() => {
			this.setOptionData(optionData);
			this.optionsLoaded = true;
		});
	}

	@action setStartMenuState(state: StartMenuState){
		this.startMenuState = state;
	}

	@action setOptionData(data){
		if(!_.isNil(data.startMenuState)){
			this.startMenuState = data.startMenuState;
		}
		if(!_.isNil(data.projectDashboardLayout)){
			this.projectDashboardLayout = data.projectDashboardLayout;
		}
		if(!_.isNil(data.projectDashboardSort)){
			this.projectDashboardSort = data.projectDashboardSort;
		}
		if(!_.isNil(data.pinnedProjects)){
			this.pinnedProjects = data.pinnedProjects;
		}
		if(!_.isNil(data.lastLocation)){
			this.lastLocation = data.lastLocation;
		}
		if(!_.isNil(data.introModal)){
			this.introModal = data.introModal;
		}
		if(!_.isNil(data.releaseVersionViewed)){
			this.releaseVersionViewed = data.releaseVersionViewed;
		}
	}

	@action setProjectDashboardLayout(layout: ProjectDashboardLayout){
		this.projectDashboardLayout = layout;
	}

	@action setProjectDashboardSort(sort: Sort){
		this.projectDashboardSort = sort;
	}

	@action pinProject(projectId: string){
		this.pinnedProjects.push(projectId);
	}

	@action unpinProject(projectId: string){
		this.pinnedProjects = this.pinnedProjects.filter(p => p !== projectId);
	}

	@action toggleProjectPin(projectId: string){
		let found = false;
		this.pinnedProjects.slice().forEach((pin) => {
			if(pin == projectId){
				found = true;
				return false;
			}
		});

		if(found){
			this.unpinProject(projectId);
		}
		else{
			this.pinProject(projectId);
		}
	}

	@action setLastLocation(location: string){
		this.lastLocation = location;
	}
}



// WEBPACK FOOTER //
// ./src/stores/ui-store.ts